import { getJsonAsync } from './fetchConfig';

export const getOrganizations = (countryCode, query) =>
  getJsonAsync(`organizations/${countryCode}?query=${encodeURIComponent(query)}`);
